/* Copyright 2013 - 2024 Waiterio LLC */

export default 'https://assets.waiterio.com/icons/favicon-196x196.png'
